/**************************************************************/
/* This file is excluded from git and is environment specific */
/**************************************************************/
var _ENV="DEV";
var _URL="https://dev.simplyconvert.com";

var _MODERN_ANIMATION_LENGTH = 750;
var _MODERN_ARRIVE_ANIMATION_EASING = 'easeOutExpo';
var _MODERN_DEPART_ANIMATION_EASING = 'easeInExpo';

var _MAX_CHARACTER_LONG = 50000;
var _MAX_CHARACTER_MEDIUM = 10000;
var _MAX_CHARACTER_SHORT = 1000;
